<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import OurLocation from '$lib/PageSections/OurLocation/ourLocation.svelte';

	import staff from './images/about-us-careers-001.png';
	import youtubeThumbnail from './images/careers-YT.jpg';
</script>

<Section backgroundColor={'white'}>
	<Image src={staff} alt="Indow acoustic consultants standing in a line." />
	<h2>INDOW IS HIRING</h2>
	<p>
		Join a cleantech startup team building a great company while making a
		positive difference in our world. We're committed to continuous learning as
		we innovate ever better ways to make Indow window inserts more accessible to
		customers. If you love creative collaboration and disciplined execution, we
		hope you'll apply.
	</p>
	<p>
		Our work is challenging, but we believe in each other and promote from
		within. Some in our
		<a href="/about-indow/management-team">senior executive team</a> started in entry-level
		positions and grew to take on greater responsibility. There's no place like our
		startup culture to learn new skills and make a huge impact on the company's future.
		Each day, you'll feel satisfaction knowing your work is resulting in dramatically
		lower carbon emissions while helping people enjoy quiet, comfort and lower energy
		bills.
	</p>
	<p>
		Hint: <a href="/about-indow">Check out our company mission & vision</a>.
		They really matter to us!
	</p>

	<h2>Diversity, Equity, and Inclusion at Indow</h2>
	<p>
		Indow is committed to a nondiscriminatory hiring approach and we promote
		equal opportunity for employment and advancement. We respect and value
		diverse life experiences and heritages and want all voices to be valued and
		heard. We believe diversity, equity, and inclusion leads to more expansive
		and varied ideas, information, and perspectives, making us more creative and
		improving our decision-making power.
	</p>
	<p>
		As an employee, you would have the opportunity to join the DEI committee,
		dedicated to maintaining a diverse, equitable, and inclusive environment at
		Indow. This means, affecting procedure, events, and always taking a
		transparent and strategic approach. Our most recent <a
			href="https://www.linkedin.com/pulse/centering-dei-indow-culture-sam-pardue/"
			target="_blank"
			rel="noreferrer">team member survey</a
		> received top marks on managers' ability to be inclusive and open to new ideas,
		but we always have room to grow.
	</p>

	<h2>Benefits</h2>
	<ul>
		<li>Medical and dental insurance</li>
		<li>Flexible Savings Account</li>
		<li>Short Term Disability</li>
		<li>Short Term Disability and AD&D/Life Insurance</li>
		<li>401K with employer match</li>
		<li>
			Paid Vacation (up to two weeks in your first three years, increasing with
			tenure)
		</li>
		<li>Paid Sick Leave (up to 40 hours per calendar year)</li>
		<li>Stock Options for full-time employees</li>
		<li>
			Opportunities to earn additional vacation time by participating in our
			Alternative Transit or Physical Activity Incentive Programs
		</li>
	</ul>

	<h2>Join Us!</h2>
	<p>
		Below are the jobs we’re currently looking to fill. All positions are
		available for candidates in the Portland, OR metro area.
	</p>
	<p>
		Depending on the position, we may accept candidates working from other areas
		of Oregon and additional states. See individual job descriptions for more
		information!
	</p>
	<p>
		To apply to our team, please fill out our <a
			href="/static/pdfs/Employment-Application-MH-10-19-21.pdf"
			>job application
		</a>
		and send your resume to
		<a href="mailto:opportunity@indowwindows.com"
			>opportunity@indowwindows.com</a
		>
	</p>
</Section>

<Section backgroundColor="blue">
	<h2>PRODUCTION TEAM MEMBER</h2>
	<p>
		Indow is looking for Production Team Members to join our ambitious and
		growing organization. We are seeking experienced, detail oriented candidates
		who are eager to learn and work in a collaborative environment to meet
		production goals, adhering to strict quality guidelines. Team members will
		be cross-trained in multiple facets of the production process and will be
		expected to train others.
	</p>
	<ul>
		<li>— Shifts: Monday - Thursday from 7:30am-6pm —</li>
		<li>— Work location: Portland, OR —</li>
		<li>
			— Hourly Pay Rate: $17.25, increasing with tenure and mastery of various
			steps in the production line. —
		</li>
	</ul>
	<Button
		href="https://docs.google.com/document/d/1GX1e7PIRJgKQtSG_H-2WcAza0wmbMFns9Q820ViPuIs/edit?usp=sharing"
		>Learn More about this position here</Button
	>
</Section>

<Section class="max-md:py-0">
	<Youtube
		posterImageSrc={youtubeThumbnail}
		videoId="BQxcaIr9-qo"
		title="An Inside Look at the Indow Production and Manufacturing Team"
	/>
</Section>

<OurLocation />
<Awards />
<FeaturedArticles />
